/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Alert } from 'bold-ui'
import { formatDurationToMonthsAndDays } from 'util/date/formatDuration'

import { MCHAT_RESULTADOS, MChatRiscoPrevioRelevanteInfoModel } from '../mchat/model-mchat'

interface MChatRAnteriorAlertProps {
  alerta: MChatRiscoPrevioRelevanteInfoModel
}

export function MChatRAnteriorAlert(props: Readonly<MChatRAnteriorAlertProps>) {
  const { alerta } = props

  const tempo = formatDurationToMonthsAndDays(alerta.duracaoDesdeRiscoPrevio)

  const { status, title } = MCHAT_RESULTADOS[alerta.risco]

  return (
    <Alert type={status} inline style={{ width: '100%' }}>
      Foi calculado <strong>{title}</strong> {tempo.toLowerCase()}. Investigue possíveis encaminhamentos para
      intervenção precoce.
    </Alert>
  )
}
